<template>

<div>

  <LDBsTable
    url="banks"
    defaultSort="name"
    defaultOrder="asc"
    :query="queryToUse"
    :columns="columns"
    :clear="clear"
    :defaultOptions='options'
  >
    <div class="form-group col-lg-12">
      <label>{{ $t('name') }}</label>
      <input
        type="text"
        class="form-control"
        id="name"
        name="name"
        :placeholder="$t('type_name')"
        v-model="query.name"
      >
    </div>
  </LDBsTable>

</div>

</template>

<script>
import LDBsTable from '@/components/shared/LDBsTable'
import { mapState } from 'vuex'

export default {
  name: 'BankList',

  components: {
    LDBsTable
  },

  data () {
    return {
      columns: [
        {
          title: 'ID',
          field: 'id'
        },
        {
          title: this.$t('name'),
          field: 'name',
          sortable: true
        },
        {
          key: 'id',
          field: 'id',
          align: 'center',
          width: '100%',
          formatter: function (value) {
            return `<a href="#/main/bank/${value}" class="edit btn btn-action btn-primary btn-circle light-bottom-shadow text-white"><i class="fas fa-pen"></i></a>`
          },
        }
      ],
      options: {
        exportOptions: { fileName: 'bancos' }
      },
      query: {
        id: undefined,
        name: ''
      },
      queryToUse: {}
    }
  },

  computed: {
    ...mapState({
      lastquery: state => state.filtershistory.query
    })
  },

  methods: {
    clear() {
      this.query.name = ''
    }
  },

  beforeMount() {
    this.queryToUse = this.lastquery['bank'] ? this.lastquery['bank'] : this.query
  },

  mounted () {
    if (this.lastquery['bank']) {
      for (const [key, value] of Object.entries(this.lastquery['bank'])) {
        this.query[key] = value
      }
    }

    this.queryToUse = this.query
  },

  destroyed () {
    this.$store.dispatch('filtershistory/setQuery', { key: 'bank', query: this.query })
  },
}
</script>
